import { User } from "src/common/models/user";
import * as Actions from "./action";
import * as ActionTypes from "./actionTypes";
import { UserError, UserErrorOrigin } from "./types";
import { ErrorAction } from "src/common/apiLoader/state/actions";
import { parseDataKey } from "src/common/util";
import { UserRole } from "src/common/models/userRole";

export interface UserState {
    users: User[]
    error?: UserError
    upsertUserSuccess: boolean
    userRoles?: UserRole[]
    currentUser?: User
    updatetUserPasswordSuccess: boolean
}

const initialState: UserState = {
    users: [],
    upsertUserSuccess: false,
    updatetUserPasswordSuccess: false,
}

export default (state: UserState = initialState, action: any): UserState => {
    switch (action.type) {
        case ActionTypes.GET_USERS_API: {
            return {
                ...state,
                users: [],
                error: undefined
            }
        }
        case ActionTypes.GET_USERS_API_SUCCESS: {
            const successAction = action as Actions.GetUsersSuccessAction;

            return {
                ...state,
                users: parseDataKey(successAction.users),
                error: undefined
            }
        }
        case ActionTypes.GET_USERS_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: UserErrorOrigin.GET_USERS,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.UPSERT_USER_API: {
            return {
                ...state,
                upsertUserSuccess: false,
                error: undefined,
            }
        }
        case ActionTypes.UPSERT_USER_API_SUCCESS: {
            return {
                ...state,
                upsertUserSuccess: true,
            }
        }
        case ActionTypes.UPSERT_USER_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: UserErrorOrigin.UPSERT_USER,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_USER_ROLES_API: {
            return {
                ...state,
                userRoles: undefined,
                error: undefined
            }
        }
        case ActionTypes.GET_USER_ROLES_API_SUCCESS: {
            const successAction = action as Actions.GetUserRolesSuccessAction;

            return {
                ...state,
                userRoles: parseDataKey(successAction.userRoles),
            }
        }
        case ActionTypes.GET_USER_ROLES_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: UserErrorOrigin.GET_USER_ROLES,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.GET_USER_BY_ID_API: {
            return {
                ...state,
                currentUser: undefined,
                error: undefined
            }
        }
        case ActionTypes.GET_USER_BY_ID_API_SUCCESS: {
            const successAction = action as Actions.GetUserByIdSuccessAction;

            return {
                ...state,
                currentUser: successAction.user,
            }
        }
        case ActionTypes.GET_USER_BY_ID_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: UserErrorOrigin.GET_USER_BY_ID,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.UPDATE_USER_PASSWORD_API: {
            return {
                ...state,
                updatetUserPasswordSuccess: false,
                error: undefined,
            }
        }
        case ActionTypes.UPDATE_USER_PASSWORD_API_SUCCESS: {
            return {
                ...state,
                updatetUserPasswordSuccess: true,
            }
        }
        case ActionTypes.UPDATE_USER_PASSWORD_API_ERROR: {
            const errorAction = action as ErrorAction;

            return {
                ...state,
                error: {
                    type: UserErrorOrigin.UPDATE_USER_PASSWORD,
                    detail: errorAction.error,
                }
            }
        }
        case ActionTypes.CLEAN_CURRENT_USER: {
            return {
                ...state,
                currentUser: undefined,
                updatetUserPasswordSuccess: false,
            }
        }
    }
    return state;
};
